import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createStaffValidationForm } from "../../utils/validationSchema";
import TextField from "../Reusable/Form/TextInput";
import Form from "../../layouts/Form";

const CreateStaff = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(createStaffValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <TextField
          label={"Full Name"}
          register={register("full_name")}
          errors={errors?.full_name}
        />
        <TextField
          label={"Email"}
          register={register("email")}
          errors={errors?.email}
        />
        <TextField
          label={"Mobile Number"}
          register={register("mobile_number")}
          errors={errors?.mobile_number}
        />
        <TextField
          label={"Designation"}
          register={register("designation")}
          errors={errors?.designation}
        />
        <TextField
          label={"Secondary Contact"}
          register={register("secondary_contact")}
          errors={errors?.secondary_contact}
        />
        <TextField
          label={"Full Address"}
          register={register("full_address")}
          errors={errors?.full_address}
        />
      </div>
    </Form>
  );
};

export default CreateStaff;
